import isNil from 'lodash/isNil';

import type { AppData } from '../../types/app_data';
import { StepCategory } from '../../types/app_data';
import { isRefiQualifiedWithEstimatedMileage } from '../../utils/app_data';
import type { Step } from '../types/step';

export const NotInsuredBeforeOnboardingStep: Step = {
  // Ask why user is not insured
  id: 'askNotInsured',
  pathname: '/notinsured',
  canShow: (appData: AppData) => {
    if (appData.isFromMAL) {
      return false;
    }

    // Don't ask this if the user is onboarding lite
    if (appData.isOnboardingLite) {
      return false;
    }

    // Don't ask this if the user answered they are insured
    if (appData.signupParams?.isAutoInsured !== false) {
      return false;
    }

    if (appData.signupParams?.needNNOInsurance === true) {
      return false;
    }    

    // If insurance service is selected or refi service is selected and user is qualified
    if (
      appData.selectedService?.insurance ||
      (appData.selectedService?.refi && isRefiQualifiedWithEstimatedMileage(appData))
    ) {
      if (appData.featureData?.askICVBeforeOnboarding) {
        return true;
      }
    }

    return false;
  },
  hasData: () => true,
  hasOwnData: (appData: AppData) => !isNil(appData.signupParams?.notInsuredReason),
  category: () => StepCategory.Insurance,
};
